import React from 'react'
import Parser from 'html-react-parser';
import moment from 'moment';

const StepFour = ({ styles, prevStep, nextStep, detail }) => {
    const skill = detail && detail.KEYWORDS && detail.KEYWORDS.map((d, i) => {
        return d.SKILL
    })
    console.log(detail)
    return (
        <React.Fragment>

            {detail &&
                < table className="table mb-0">
                    <tbody>
                        <tr>
                            <td className={`${styles['table-title']}`}>Job Title</td>
                            <td className={`${styles['table-data']}`}>{detail.JOB_TITLE}</td>
                        </tr>
                        {/* <tr>
                                <td>Employment Type</td>
                                <td>{detail.EMPLOYMENT_TYPE_ID}</td>
                            </tr> */}
                        <tr>
                            <td className={`${styles['table-title']}`}>Work Location</td>
                            <td className={`${styles['table-data']}`}>{detail.IS_FIELD_JOB ? (detail.ADDRESS) + 'Field Job' : detail.IS_WORK_FROM_HOME_DURING_COVID === 'Y' && detail.TYPE_OF_WORK_FROM_HOME === 'WFHDC' ? (detail.ADDRESS) + 'Hybrid' : detail.IS_WORK_FROM_HOME_DURING_COVID === 'Y' && detail.TYPE_OF_WORK_FROM_HOME === 'PRJ' ? 'Remote Job' : detail.ADDRESS}</td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Key Skills</td>
                            <td className={`${styles['table-data']}`}>
                                {skill.toString().replace(/,/g, ', ')}
                            </td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Work Experience (Years)</td>
                            <td className={`${styles['table-data']}`}>{`${detail.WORK_EXP_MIN}-${detail.WORK_EXP_MAX} year`}</td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Job Description</td>
                            <td className={`${styles['table-data']}`}>{detail.JOB_DETAILS ? Parser(detail.JOB_DETAILS) : "NA"}</td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Annual Salary Range</td>
                            <td className={`${styles['table-data']}`}>{`${detail.CTC_MIN / 100000}-${detail.CTC_MAX / 100000} LPA`}</td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Hide salary details from candidates</td>
                            <td className={`${styles['table-data']}`}>{detail.IS_HIDE_SALARY_FROM_CANDIDATE === 'Y' ? 'Yes' : 'No'}</td>
                        </tr>

                        <tr>
                            <td className={`${styles['table-title']}`}>Location</td>
                            <td className={`${styles['table-data']}`}>
                                {detail && detail.CITY_ID && detail.CITY_ID.map((d, i) => {
                                    return d.CITY
                                }).join(', ')}
                            </td>
                        </tr>


                        <tr>
                            <td className={`${styles['table-title']}`}>Number Of Vacancies </td>
                            <td className={`${styles['table-data']}`}>{detail.NO_OF_VACANCIES}</td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Minimum Qualification</td>
                            <td className={`${styles['table-data']}`}>
                                {detail && detail.QUALIFICATION_ID && detail.QUALIFICATION_ID.map((d, i) => {
                                    return d.QUALIFICATION_NAME
                                }).join(', ')}
                            </td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Degree</td>
                            <td className={`${styles['table-data']}`}>
                                {detail?.EDUCATION_QUALIFICATION_ID?.length > 0
                                    ? detail.EDUCATION_QUALIFICATION_ID.map(d => d.COURSE_STREAM).length > 0 ? detail.EDUCATION_QUALIFICATION_ID.map(d => d.COURSE_STREAM).join(', ') : '--'
                                    : '--'}


                            </td>
                        </tr>
                        <tr>
                            <td className={`${styles['table-title']}`}>Specialization</td>
                            <td className={`${styles['table-data']}`}>
                                {detail && detail.COURSE_SPECIALIZATION?.length > 0 ? detail.COURSE_SPECIALIZATION.map((d, i) => {
                                    return d.SPECIALIZATION
                                }).join(', ') : '--'}
                            </td>
                        </tr>
                        {detail.IS_INCLUDE_WALK_IN === 'Y' &&
                            <React.Fragment>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Include walk-in distance</td>
                                    <td className={`${styles['table-data']}`}>{detail.IS_INCLUDE_WALK_IN}</td>
                                </tr>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Walk-In Start Date</td>
                                    <td className={`${styles['table-data']}`}>{moment(detail.WALK_IN_START_DATE).format('DD-MMM-YYYY')}</td>
                                </tr>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Walk-In Start Timing</td>
                                    <td className={`${styles['table-data']}`}>{detail.WALK_IN_START_TIME == "null" ? "NA" : detail.WALK_IN_START_TIME}</td>
                                </tr>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Walk-In End Timing</td>
                                    <td className={`${styles['table-data']}`}>{detail.WALK_IN_END_TIME == "null" ? 'NA' : detail.WALK_IN_END_TIME}</td>
                                </tr>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Duration (Days)</td>
                                    <td className={`${styles['table-data']}`}>{detail.DURATION == "null" ? "NA" : detail.DURATION}</td>
                                </tr>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Contact Person</td>
                                    <td className={`${styles['table-data']}`}>{detail.CONTACT_PERSON == "null" ? "NA" : detail.CONTACT_PERSON}</td>
                                </tr>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Contact Number</td>
                                    <td className={`${styles['table-data']}`}>{detail.MOBILE_NUMBER == "null" ? "NA" : detail.MOBILE_NUMBER}</td>
                                </tr>
                                <tr>
                                    <td className={`${styles['table-title']}`}>Venue</td>
                                    <td className={`${styles['table-data']}`}>{detail.VENUE}</td>
                                </tr>
                            </React.Fragment>

                        }

                        <tr>
                            <td className={`${styles['table-title']}`}>Company Name</td>
                            <td className={`${styles['table-data']}`}>{detail.COMPANY_NAME == "null" ? "NA" : detail.COMPANY_NAME}</td>
                        </tr>


                    </tbody>
                </table>}

            <div className='row'>
                <div class="col-12 py-3">
                    <div className='d-flex justify-content-between'>
                        <button type='button' className='btn btn-secondary' style={{ border: 'none', outline: 'none', borderRadius: "4px" }} onClick={() => prevStep()}>Previous</button>
                        <button type='button' className={`${styles['btn-next']} btn`} style={{ border: 'none', outline: 'none', borderRadius: "4px" }} onClick={() => nextStep()} >Continue</button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )

}

export default StepFour